export enum OnboardingOrganisationRequirements {
  NotApplicable = 0,
  Skipped = 1,
  Depreciation = 10,
  Leases = 20,
  DepreciationAndLeases = 30,
}
